// import axios from "axios";

/**
 * TYPE
 */
export type ApiErrorDataResult= {
  displayableMessage: boolean | null,
  errorCode: string | null,
  errorMessageArgs: string | null,
  exceptionClassName: string | null,
  filed: string | null,
  message: string | null,
  object: string | null,
};

export type ApiErrorData = {
  result: ApiErrorDataResult | ApiErrorDataResult[];
};

export type OptionGetErrorMessage = {
  DEFAULT_ERROR_MESSAGE?: string,
  localFirst?: boolean,
  usingServerMsg?: boolean
};

/**
 * 서버에서 받은 ErrorData로 부터 애러 Result 뽑아내기
 */
export const getErrorResult = (errorData: ApiErrorData): ApiErrorDataResult=>{
  const ErrorResult = Array.isArray(errorData.result) ? errorData.result[0]: errorData.result;

  return ErrorResult;
};

/**
 * 애러 Result로 부터 애러 메시지 뽑아내기
 */
export const getErrorMessage = (
  {message: serverMessage, errorCode, displayableMessage}: ApiErrorDataResult,
  MAPPED_CODE_TO_MESSAGE: Record<string, string>,
  {
    DEFAULT_ERROR_MESSAGE = '',
    localFirst = false,
    usingServerMsg = true
  }: OptionGetErrorMessage = {}
) => {
  const localErrorMessage = errorCode && MAPPED_CODE_TO_MESSAGE[errorCode];

  // 서버 메시지 사용 함
  if(usingServerMsg && serverMessage && displayableMessage) {
    return ( localFirst && localErrorMessage ) ? localErrorMessage : serverMessage;
  }

  // 서버 메시지 사용 안함
  return localErrorMessage || DEFAULT_ERROR_MESSAGE;
};

/** 사용예시 */

/*
async function testCallApi(){
  try{
    const result = await axios.get('/test/api');

  }catch(error){
    if (axios.isAxiosError<ApiErrorData>(error) && error.response?.data) {
      const errorResult = getErrorResult(error.response.data);
      const {errorCode} = errorResult;

      const errorMessage= getErrorMessage(errorResult, {'error-code-1': '비로그인 계정입니다'}, {DEFAULT_ERROR_MESSAGE:'다음에 다시 이용해주세요', localFirst: true, usingServerMsg: true});
    }
  }
}
*/

/**
 * ${userName} 님을 ${guildName} 에서 추방하시게습니까?
 * 같은 메시지를 치환시킨다.
 *
 * MessageSubstitutionObj({
 *   msg: {userName} 님을 ${guildName} 에서 추방하시게습니까?,
 *   masgArgs: {
 *      userName: 'cress',
 *      guildName: 'cat_guild'
 *   }
 * })
 *
 */
type MessageSubstitutionObj = {
  msg: string,
  msgArgs: Record<string, string>
};

export const msgSubstitution = ({msg, msgArgs}: MessageSubstitutionObj): string => {
  const matches = [...msg.matchAll(/\${([\s]*[^;\s{]+[\s]*)\}/g)];

  for (const {0: originString, 1: key} of matches) {
    if(!msgArgs[key]) {
      console.error(`Not a msgArg for ${key}`);
      continue;
    }

    msg = msg.replace(originString, msgArgs[key]);
  }

  return msg;
};



